import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  Gutter,
  Layout,
  LayoutItem,
  Paragraph,
  ParagraphHeader,
  SmallHeader,
  useBreakpoint,
} from '@axiom/ui';

import ReferralDollars from '../../public/svg/referral-dollars.svg';
import ReferralHandshake from '../../public/svg/referral-handshake.svg';
import { EnvUtil } from '../../utils/env-util';

export const UsefulLinks = () => {
  const { isSmallScreen } = useBreakpoint();
  return (
    <Card name="USEFUL-LINKS">
      <CardHeader>
        <SmallHeader name="HEADER">Referral Programs</SmallHeader>
      </CardHeader>
      <CardSection>
        <Layout direction="vertical" verticalGutter="32px">
          <Layout
            horizontalGutter="24px"
            wrap={isSmallScreen}
            name="REFER-CLIENT"
          >
            <LayoutItem>
              <ReferralHandshake width="50px" height="50px" />
              <Gutter bottom="16px" />
            </LayoutItem>
            <LayoutItem fluid>
              <ParagraphHeader name="CLIENT_HEADER">
                Refer a Client
              </ParagraphHeader>
              <Gutter bottom="8px" />
              <Paragraph name="CLIENT_DESCRIPTION">
                Refer a new business opportunity and earn up to $5,000 as a
                thank you.
              </Paragraph>
              <Gutter bottom="8px" />
              <a
                href={EnvUtil.referClientUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-test="REFER_A_CLIENT_BUTTON"
              >
                Referral Link
              </a>
            </LayoutItem>
          </Layout>
          <Layout
            horizontalGutter="24px"
            wrap={isSmallScreen}
            name="REFER-LAWYER"
          >
            <LayoutItem fluid>
              <ReferralDollars width="50px" height="50px" />
              <Gutter bottom="16px" />
            </LayoutItem>
            <LayoutItem>
              <ParagraphHeader name="LAWYER_HEADER">
                Refer a Lawyer
              </ParagraphHeader>
              <Gutter bottom="8px" />
              <Paragraph name="LAWYER_DESCRIPTION">
                Do you know a top-caliber lawyer who might be interested in
                working at Axiom? Send them our way!
              </Paragraph>
              <Gutter bottom="8px" />
              <a
                href={EnvUtil.referLawyerUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-test="REFER_A_LAWYER_BUTTON"
              >
                Referral Link
              </a>
            </LayoutItem>
          </Layout>
        </Layout>
      </CardSection>
    </Card>
  );
};
